export default __webpack_public_path__ + "860a331372d64f4483e4d30c0d33a04c.png";